import { createContext, useContext } from 'react'

export type DialogVariant = 'info' | 'success' | 'warning' | 'danger' | 'error'

export type DialogOptions = {
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: DialogVariant
  duration?: number
}

export type DialogApi = {
  alert: (message: string, options?: Omit<DialogOptions, 'message'>) => Promise<void>
  confirm: (message: string, options?: Omit<DialogOptions, 'message'>) => Promise<boolean>
  toast: (message: string, options?: Omit<DialogOptions, 'message' | 'title'>) => void
}

export const DialogContext = createContext<DialogApi | undefined>(undefined)

export const useDialog = () => {
  const context = useContext(DialogContext)
  if (!context) {
    throw new Error('useDialog must be used within DialogProvider')
  }
  return context
}
